module.exports = __webpack_public_path__ + "bf00bc35c700478fac161b70fd7acffe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000CEM.png
// module id = 1435
// module chunks = 0